import { render, staticRenderFns } from "./MonthPeople.vue?vue&type=template&id=484f9254"
import script from "./MonthPeople.vue?vue&type=script&lang=js"
export * from "./MonthPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports